import { ContentfulEntryType } from './contentful-entry.type';

export class PersistenceType extends ContentfulEntryType {
  public get title(): string {
    return this.fields['title'];
  }

  public get roundStartCopy(): string {
    return this.fields['roundStartCopy'];
  }

  public get startRoundButtonText(): string {
    return this.fields['startRoundButtonText'];
  }

  public get endExerciseButtonText(): string {
    return this.fields['endExerciseButtonText'];
  }

}


